
// import {
//   mockStatistics, mockConferenceInfo, mockHeroSlides, mockConferences, homeIndex, newsInfoList, newsDetail1, newsDetail2, newsDetail3, cases,
//   experts, institutions, conferenceUnits, eventsDetail
// } from '@/mock/data'

import api from '@/api/axiosConfig';
 

export const getNewsData = (newsType,page, pageSize) =>api.get('/news/list', { params: { newsType,page, pageSize } })
export const getNewsDetail = (id) =>api.get('/news/detail', { params: { id } })

export const getNewsRecommend  = (newsType) =>api.get('/news/recommend', { params: { newsType } })
export const getColumns = (home) =>api.get(`/column/columns?showHome=${home}`)
export const getColumnDetail = (id,page,pageSize) =>api.get(`/column/detail?id=${id}&page=${page}&pageSize=${pageSize}`)
export const getColumnNewsDetail = (columnId,id) =>api.get(`/column/newsDetail?id=${id}&columnId=${columnId}`)
export default {
  getNewsData,
  getNewsDetail,
  getNewsRecommend,
  getColumns,
  getColumnDetail,
  getColumnNewsDetail 
}